var _path, _path2, _path3, _line, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Zip50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M32.8,9H16.1c-1.7,0-3.1,1.4-3.1,3.1v31.8c0,1.7,1.4,3.1,3.1,3.1h23.8c1.7,0,3.1-1.4,3.1-3.1V19.1 c0-0.6-0.2-1.1-0.6-1.5l-8.1-8C33.9,9.2,33.4,9,32.8,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M38.5,21.9v-7.4h-6c-1.7,0-3-1.3-3-3v-6h-17c-1.7,0-3,1.3-3,3v8.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M9.5,35.5v4c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M9.5,35.5h-1c-0.6,0-1-0.4-1-1v-11c0-0.6,0.4-1,1-1h20.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M33.8,22.5h5.7c0.6,0,1,0.4,1,1v11c0,0.6-0.4,1-1,1h-25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M24,33c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C25,32.6,24.6,33,24,33z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M30,25h-2c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1s1-0.4,1-1v-1h1c1.7,0,3-1.3,3-3S31.7,25,30,25z M30,29h-1v-2h1 c0.6,0,1,0.4,1,1S30.6,29,30,29z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M20,33h-4c-0.4,0-0.7-0.2-0.9-0.5s-0.2-0.7,0.1-1l3-4.4H16c-0.6,0-1-0.4-1-1s0.4-1,1-1h4 c0.4,0,0.7,0.2,0.9,0.5s0.2,0.7,0,1l-3,4.4H20c0.6,0,1,0.4,1,1S20.6,33,20,33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Zip50);
export default __webpack_public_path__ + "static/media/icons8-zip-50.29316d44188697127c924b43d6fabfd1.svg";
export { ForwardRef as ReactComponent };